import * as React from 'react';
import { List } from '@material-ui/core';
import NavItem from './NavItem';
import NavGroup from './NavGroup';
import { useContext } from 'react';
import { AuthContext } from '../_auth/AuthContext';
import { GetMenu } from '../_navigation/NavMenu';

interface Props {
    classes?: any
};


const MainMenu: React.FC<Props> = (props: Props) => {

    const { user } = useContext(AuthContext);
    //const { nav, setNav } = useContext(NavigationContext);
    //const theme = useTheme();

    return user.authorized ? (
 
      <List>
        {GetMenu().map((grp,i) => (
          <NavGroup key={i} menuKey={grp.key} label={grp.label} checkPermission={grp.checkPermission} path={grp.path} iconName={grp.iconName} >
            {grp.items.filter(g => g.link === true).map((itm,ii) => (
              <NavItem key={ii} menuKey={itm.key} label={itm.label} checkPermission={itm.checkPermission} path={itm.path} iconName={itm.iconName} groupKey={grp.key}></NavItem>
                ))}
            </NavGroup> 
        ))
        }
        {/* <a href={process.env.REACT_APP_LEGACY_DASHBOARD_URL} color="Primary" style={{textDecoration: 'none'}}>
            <ListItem button>
                <Icon iconName={SupportedIcons.Legacy_Dashboard}/>
                <ListItemText>Dashboard</ListItemText>
                
            </ListItem>
          </a> */}
      </List>

    ): ( <div/> )

};

export default MainMenu;

/*
        <List>
          <NavItem path='/' key="DashBoard" locationOnly={false} iconName={SupportedIcons.DashBoard} label="DashBoard"  />
          <NavGroup path="/reports/home" key="ReportsHome" locationOnly={false} label="Reports" iconName={SupportedIcons.Assessment}>
            
            <NavItem path='/reports/home' key="ReportsOverTime" locationOnly={false} iconName={SupportedIcons.Assessment} label="Over Time" />
            <NavItem path='/reports/snapshot' key="SnapShot" locationOnly={false} iconName={SupportedIcons.PieChart} label="Snap Shot" />
          </NavGroup>
          <NavGroup path="/locations/home" key="Locations" locationOnly={true} iconName={SupportedIcons.LocalCarWash} label="Locations">

            <NavItem path='/locations/home' key="LocationHome" locationOnly={true} iconName={SupportedIcons.LocalCarWash} label="Summary"  />
            <NavItem path='/locations/equipment' key="Equipment" locationOnly={true} iconName={SupportedIcons.Router} label="Equipment"  />
          </NavGroup>
          <NavItem path='/testing' key="Testing" locationOnly={true} iconName={SupportedIcons.Details} label="Testing" />
            
        </List>
*/